var $8b8ad8904d69cbb9$exports = {};
const $8b8ad8904d69cbb9$var$toggleNavBtn = document.querySelector(".navbar__toggle");
$8b8ad8904d69cbb9$var$toggleNavBtn.addEventListener("click", ()=>{
    const navBtnContainer = document.querySelector(".navbar__links-container");
    if (navBtnContainer.classList.contains("show-links")) navBtnContainer.classList.remove("show-links");
    else navBtnContainer.classList.add("show-links");
});


//# sourceMappingURL=index.e7ec657c.js.map
